module.exports = __webpack_public_path__ + "static/img/1-02.d2b0b1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-02.png
// module id = 203
// module chunks = 0